import { Component, HostListener, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-home-career',
    templateUrl: './home-career.component.html',
    styleUrls: ['./home-career.component.scss']
})
export class HomeCareerComponent implements OnInit {
    @Input() content: any;
    animateContent: boolean = false;
    imageIsLoaded: boolean = false;
    careergallery: any;
    activeSlide: number = 0;
    width: number = 0;
    labelwidth: number = 0;
    interval;
    isNotPaused: boolean = false;
    screenWidth: number = 0;
    lastActive: number = 0;

    constructor() {
        this.onResize();
    }

    ngOnInit() {
        this.interval = setInterval(() => {
            if (this.isNotPaused) {
                if (this.width >= 100) {
                    this.width = 0;
                    this.nextImage();
                } else {
                    this.width++;
                }
            }
        }, 150);
    }

    public onIntersection({ target, visible }: { target: Element; visible: boolean }): void {
        if (visible) {
            this.animateContent = true;
            this.careergallery = this.content.gallery;
            if (this.screenWidth > 1024) {
                this.labelwidth = 150 / this.careergallery.length;
            } else {
                this.labelwidth = 150 / this.careergallery.length;
            }
            this.isNotPaused = true;
        } else {
            this.isNotPaused = false;
        }
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.screenWidth = window.innerWidth;
    }

    nextImage() {
        this.activeSlide++;
        if (this.activeSlide >= this.careergallery.length) {
            this.activeSlide = 0;
        }
        setTimeout(() => {
            this.lastActive++;
            if (this.lastActive >= this.careergallery.length) {
                this.lastActive = 0;
            }
        }, 300);
    }

    activeSlideDots(i) {
        this.activeSlide = i;
        if (this.activeSlide >= this.careergallery.length) {
            this.activeSlide = 0;
        }
        if (this.activeSlide < 0) {
            this.activeSlide = this.careergallery.length - 1;
        }
        setTimeout(() => {
            this.lastActive = i;
        }, 300);
    }

    onSwipeLeft() {
        if (this.screenWidth <= 1024) {
            var nextSlide = this.activeSlide + 1;
            this.activeSlideDots(nextSlide);
        }
    }

    onSwipeRight() {
        if (this.screenWidth <= 1024) {
            var prevSlide = this.activeSlide - 1;
            this.activeSlideDots(prevSlide);
        }
    }
    
    imageLoaded(i) {
        document.getElementById('career-image-' + i).classList.add('loaded');
    }
}
